var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWelcomePc3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2844_23654)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.6665,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "#E1DEF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2844_23654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2844_23654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 18.7832C11.4444 18.7498 11.5528 18.7221 11.6583 18.6998C11.7639 18.6776 11.8778 18.6665 12 18.6665H12.6667V10.6665H12C11.8111 10.6665 11.6528 10.7304 11.525 10.8582C11.3972 10.9859 11.3333 11.1443 11.3333 11.3332V18.7832ZM12 22.6665C11.4444 22.6665 10.9722 22.4721 10.5833 22.0832C10.1944 21.6943 10 21.2221 10 20.6665V11.3332C10 10.7776 10.1944 10.3054 10.5833 9.9165C10.9722 9.52762 11.4444 9.33317 12 9.33317H16.6667V10.6665H14V18.6665H18V16.6665H19.3333V19.9998H12C11.8111 19.9998 11.6528 20.0637 11.525 20.1915C11.3972 20.3193 11.3333 20.4776 11.3333 20.6665C11.3333 20.8554 11.3972 21.0137 11.525 21.1415C11.6528 21.2693 11.8111 21.3332 12 21.3332H20.6667V15.9998H22V22.6665H12ZM19.6667 15.9998C19.6667 14.9776 20.0222 14.1109 20.7333 13.3998C21.4444 12.6887 22.3111 12.3332 23.3333 12.3332C22.3111 12.3332 21.4444 11.9776 20.7333 11.2665C20.0222 10.5554 19.6667 9.68873 19.6667 8.6665C19.6667 9.68873 19.3111 10.5554 18.6 11.2665C17.8889 11.9776 17.0222 12.3332 16 12.3332C17.0222 12.3332 17.8889 12.6887 18.6 13.3998C19.3111 14.1109 19.6667 14.9776 19.6667 15.9998Z",
    fill: "#62648F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2844_23654"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.6665,
    y: 2.6665,
    width: 26.6667,
    height: 26.6667,
    rx: 13.3333,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePc3);
export default __webpack_public_path__ + "static/media/welcome_pc_3.de267f1825c134cd72ee7a38f5d840ca.svg";
export { ForwardRef as ReactComponent };